// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yC5x","colMin":"styles_colMin__BK7mF"};